import React, { Component } from 'react'
import { Toolbar } from 'primereact/toolbar';
import { BreadCrumb } from 'primereact/breadcrumb';
import AddQustion from './addQustion';
import { Toast } from 'primereact/toast';
import Navbar from './../navbar';

import FetchQuestions from './fetchQuestions';
import PreviewQuestion from './common/previewQuestion';
import Test from './common/test';
import './styles.scss';
import Authorizer, { PERMISSIONS } from '../session/authorizer';
import DuplicateQChecker from './duplicateQChecker';
const items = [
    { label: 'Academics' },
    { label: 'Examinations' },
    { label: 'Question Bank', className: 'ma-active-item' },
    // { label: 'Role Creation', className: 'ma-active-item' }
];

const home = { icon: 'pi pi-home' }



export default class QuestionBank extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTab: 1,
            editQuestion: null
            //   editQuestion: { "boardId": "498fc658-d02f-4fd1-9181-0fb3912a0046", "classId": "0d438539-a00d-4e7c-8d3e-fb69b5115ac7", "questionId": "quwcz6", "attachmentUrl": "2e7e2ed0-93c3-11ec-8b22-b9072e580be7-3bbf81e0-90a6-11ec-9952-0772e613770a-5cf25c00-9085-11ec-a023-99336dc287ba-3ab6ecb0-c61d-11eb-a156-dd39ba84a64d-24.JPG", "boardName": null, "chapterId": "2dd40f6d-ea93-4f94-aa3f-7469bfbe9e3f", "chapterName": "Some Basic Concepts in Chemistry", "className": "CLASS XI", "difficulty": "Easy", "examType": ["JEE Advanced"], "explainationAttachment": "", "explanation": "eere", "groupId": "f416478b-6f24-465f-9740-9088380cdfd5", "groupName": "NO_GROUP", "hint": "rerererrr", "hintAttachment": "", "key": "A", "language": [], "options": [{ "id": "A", "imageUrl": "32d776d0-93c3-11ec-8b22-b9072e580be7-a0525360-7eab-11ec-88f1-d11a2f94386b-007a2cd0-cb3a-11ea-a087-ebd9b58bc35d-DkKRlco_atNOEbdvYph6ykOiAUtLZ3EpXL_iduSDoAU.original.fullsize.png", "value": "ewrewrewrwer" }, { "id": "B", "imageUrl": "", "value": "ewrwerwerwer" }, { "id": "C", "imageUrl": "", "value": "ewrwerwerwe" }, { "id": "D", "imageUrl": "", "value": "erererer" }], "previousExam": [{ "id": "9167a690-c63f-4c90-9957-d1802c298ea7", "data": { "exam": "JEE Advanced", "year": 2021 }, "assigned": true }], "question": "Molal depression constant for water is $1.86 \\mathrm{k} \\mathrm{kg} \\mathrm{mol}^{-1}$ the freezing point of a $0.05 \\mathrm{molal}$ solution of a non-electrolyte in water is. From a tower of height $\mathrm{H},$ a particle is thrown vertically upwards with a speed u. The time taken by the particle, to hit the ground, is n times that taken by it to reach the highest point of its path", "questionTarget": "Normal", "questionType": "SCCT", "skillType": "Critical Thinking", "source": "Meluha", "status": "Created", "subjectId": "8ed4c470-c76a-44e1-a341-3727c2ce0193", "subjectName": "Chemistry", "tags": ["erer", "etr"], "topicId": "9493e8f6-d2a1-4380-b9d9-8026da4964ad", "topicName": "Laws of Chemical combinations & Dalton theory", "videoLinking": [], "createdAt": { "$date": "2022-02-22T09:39:19.652Z" }, "updatedAt": { "$date": "2022-02-22T09:39:19.652Z" }, "__v": 0 }
        }
    }



    onEditQuestion = (editQuestion) => {


        this.setState({
            editQuestion,
            selectedTab: 3,

        })
    }


    onQuestionUpdate = () => {
        this.setState({
            editQuestion: null,
            selectedTab: 1
        })

        this.toast.show({ severity: 'success', summary: 'Question Updated', detail: 'Question successfully updated.', life: 10000 });
    }

    rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <h2 className='ma-tab-title'>Question Bank</h2>
            </React.Fragment>
        )
    }

    leftToolbarTemplate() {
        return (
            <React.Fragment>
                <BreadCrumb model={items} home={home} />
            </React.Fragment>
        )
    }


    changeTab = (tab) => {
        // if (this.state.editQuestion) {
        this.setState({ selectedTab: tab, editQuestion: null })
        // }

    }

    render() {
        const { selectedTab, editQuestion } = this.state;

        return (<>
            <Navbar >
                <div className="p-grid ma-toolbar">
                    <div className="p-col-12 p-md-1 ma-no-p">
                    </div>
                    <div className="p-col-12 p-md-11 ma-no-pm">
                        <Toolbar className="ma-toolbard" left={this.leftToolbarTemplate} right={this.rightToolbarTemplate}></Toolbar>
                    </div>
                </div>
                <div className="ask-a-doubt ma-main question-bank">
                    <div className='qb-tabs'>
                        <Authorizer permId={PERMISSIONS.EXAM_FETCH_QUESTIONS} >
                            <span onClick={() => { this.changeTab(1) }} className={selectedTab == 1 ? 'qb-active-tab' : 'qb-inactive-tab'}>Fetch Questions</span>
                        </Authorizer>
                        <Authorizer permId={PERMISSIONS.EXAM_ADD_QUESTION}>
                            <span onClick={() => { this.changeTab(2) }} className={selectedTab == 2 ? 'qb-active-tab' : 'qb-inactive-tab'}>Add Questions</span>
                        </Authorizer>

                        <Authorizer permId={PERMISSIONS.EXAM_EDIT_QUESTION}>
                            {editQuestion && <span className={selectedTab == 3 ? 'qb-active-tab' : 'qb-inactive-tab'}>Edit Questions</span>}
                        </Authorizer>

                        <Authorizer permId={PERMISSIONS.QUESTION_DUPLICATE_CHECK}>
                            <span onClick={() => { this.changeTab(4) }} className={selectedTab == 4 ? 'qb-active-tab' : 'qb-inactive-tab'}>Duplicate Check</span>
                        </Authorizer>
                    </div>
                    {
                        selectedTab == 1 && <FetchQuestions onEditQuestion={this.onEditQuestion} />
                    }
                    {
                        selectedTab == 2 && <AddQustion />
                    }
                    {
                        selectedTab == 3 && <AddQustion onQuestionUpdate={this.onQuestionUpdate} editQuestion={editQuestion} />
                    }
                    {
                        selectedTab == 4 && <DuplicateQChecker />
                    }
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />

            </Navbar>
        </>
        )
    }
}
